export default __webpack_public_path__ + "static/cooling-15431ea82edfbe26e03220066b319b57.png";